/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Add_Frame_To_EndInputs */

const en_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add 1 Frame To End`)
};

const fr_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter 1 image a la fin`)
};

const de_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge am Ende 1 Frame hinzu`)
};

const it_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi 1 fotogramma alla fine`)
};

const ru_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить 1 рамку в конец`)
};

const es_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir 1 fotograma al final`)
};

const zh_cn2_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在末尾添加 1 帧`)
};

const ja_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後に1フレームを追加`)
};

const hi_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंत में 1 फ्रेम जोड़ें`)
};

const pt_pt2_shortcut_keys_name_add_frame_to_end = /** @type {(inputs: Shortcut_Keys_Name_Add_Frame_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar 1 quadro ao final`)
};

/**
* | output |
* | --- |
* | "Add 1 Frame To End" |
*
* @param {Shortcut_Keys_Name_Add_Frame_To_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_add_frame_to_end = /** @type {((inputs?: Shortcut_Keys_Name_Add_Frame_To_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Add_Frame_To_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_add_frame_to_end(inputs)
	if (locale === "de") return de_shortcut_keys_name_add_frame_to_end(inputs)
	if (locale === "it") return it_shortcut_keys_name_add_frame_to_end(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_add_frame_to_end(inputs)
	if (locale === "es") return es_shortcut_keys_name_add_frame_to_end(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_add_frame_to_end(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_add_frame_to_end(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_add_frame_to_end(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_add_frame_to_end(inputs)
	return en_shortcut_keys_name_add_frame_to_end(inputs)
});